export const Logo = ({ light = false, className = "" }) => {
  const border = light ? "border-ivory" : "border-ink-800";
  const text = light ? "text-ivory" : "text-ink-800";
  return (
    <div className={`inline-flex flex-col items-center leading-none ${className}`} data-testid="brand-logo">
      <div className={`relative border ${border} px-3 py-1.5`}>
        <span className={`block font-display font-extrabold tracking-[0.18em] text-lg sm:text-xl ${text}`}>BODY</span>
        <span className={`block font-body font-medium tracking-[0.12em] text-[10px] sm:text-xs text-center ${text} opacity-80`}>evolution</span>
      </div>
      <div className="flex items-center gap-2 mt-1">
        <span className={`h-px w-4 ${light ? "bg-ivory" : "bg-ink-800"} opacity-60`} />
        <span className={`font-display font-bold text-xs ${text}`}>2.0</span>
        <span className={`h-px w-4 ${light ? "bg-ivory" : "bg-ink-800"} opacity-60`} />
      </div>
    </div>
  );
};
